import * as normalize from 'utils/normalize';
import getPatientName from 'utils/print/getPatientName';
import getPatientFullAddress from 'utils/print/getPatientFullAddress';
import getPatientPhone1 from 'utils/print/getPatientPhone1';
import getPatientPhone2 from 'utils/print/getPatientPhone2';
import getPatientPhone3 from 'utils/print/getPatientPhone3';
import getPatientMedicareID from 'utils/print/getPatientMedicareID';
import getOrderLinePlaceOfService from 'utils/print/getOrderLinePlaceOfService';
import getPatientDob1 from 'utils/print/getPatientDob1';
import getPatientDob2 from 'utils/print/getPatientDob2';
import getPatientDob3 from 'utils/print/getPatientDob3';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientHeightIn from 'utils/print/getPatientHeightIn';
import getPatientWeight from 'utils/print/getPatientWeight';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberFullAddress from 'utils/print/getPrescriberFullAddress';
import getPrescriberPhone1 from 'utils/print/getPrescriberPhone1';
import getPrescriberPhone2 from 'utils/print/getPrescriberPhone2';
import getPrescriberPhone3 from 'utils/print/getPrescriberPhone3';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getSupplierName from 'utils/print/getSupplierName';
import getSupplierFullAddress from 'utils/print/getSupplierFullAddress';
import getSupplierPhone1 from 'utils/print/getSupplierPhone1';
import getSupplierPhone2 from 'utils/print/getSupplierPhone2';
import getSupplierPhone3 from 'utils/print/getSupplierPhone3';
import getSupplierNSCorNPI from 'utils/print/getSupplierNSCorNPI';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineNarrativeDescriptionAndCost from 'utils/print/getOrderLineNarrativeDescriptionAndCost';
import getSignature from 'utils/print/getSignature';

const CMS848 = {
  ID: 6,
  Name: 'CMS-848 Transcutaneous Electric Nerve Stimulator',
  Type: 'CMS',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/CMS-848/1.js',
      fields: [
        {
          name: 'Certification Type/Date INITIAL 1',
          type: 'text',
          x: 88,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 2',
          type: 'text',
          x: 95,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 3',
          type: 'text',
          x: 102,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 1',
          type: 'text',
          x: 124.5,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 2',
          type: 'text',
          x: 131.5,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 3',
          type: 'text',
          x: 138,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 1',
          type: 'text',
          x: 174.5,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 2',
          type: 'text',
          x: 181,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 3',
          type: 'text',
          x: 188,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 15,
          y: 40,
          width: 96,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientFullAddress,
          x: 15,
          y: 44,
          width: 96,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Phone 1',
          type: 'text',
          getValue: getPatientPhone1,
          x: 15.5,
          y: 53.5,
          width: 10,
        },
        {
          name: 'Phone 2',
          type: 'text',
          getValue: getPatientPhone2,
          x: 28,
          y: 53.5,
          width: 10,

        },
        {
          name: 'Phone 3',
          type: 'text',
          getValue: getPatientPhone3,
          x: 40,
          y: 53.5,
          width: 14,
        },
        {
          name: 'Medicare ID',
          type: 'text',
          getValue: getPatientMedicareID,
          x: 70,
          y: 53.5,
          width: 41,
        },
        {
          name: 'Supplier Name and Address',
          type: 'text',
          getValue: (props) => {
            if (props.value) {
              return props.value;
            }
            return `${getSupplierName(props)}, ${getSupplierFullAddress(props)}`;
          },
          x: 115,
          y: 40,
          width: 86,
          height: 13,
          multiline: true,
        },
        {
          name: 'Supplier Phone 1',
          type: 'text',
          getValue: getSupplierPhone1,
          x: 118,
          y: 53.5,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 2',
          type: 'text',
          getValue: getSupplierPhone2,
          x: 130,
          y: 53.5,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 3',
          type: 'text',
          getValue: getSupplierPhone3,
          x: 143,
          y: 53.5,
          width: 14,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Supplier NSC or NPI',
          type: 'text',
          getValue: getSupplierNSCorNPI,
          x: 175,
          y: 53.5,
          width: 26,
        },
        {
          name: 'Place Of Service',
          type: 'text',
          getValue: props => getOrderLinePlaceOfService({ ...props, index: 0 }),
          x: 40,
          y: 58.5,
          width: 19,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 1',
          type: 'text',
          getValue: getPatientDob1,
          x: 125.5,
          y: 58.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 2',
          type: 'text',
          getValue: getPatientDob2,
          x: 132.5,
          y: 58.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 3',
          type: 'text',
          getValue: getPatientDob3,
          x: 139,
          y: 58.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Gender',
          type: 'text',
          getValue: getPatientGender,
          x: 152,
          y: 58.5,
          width: 5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Height',
          type: 'text',
          getValue: getPatientHeightIn,
          x: 172,
          y: 58.5,
          width: 6,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Patient Weight',
          type: 'text',
          getValue: getPatientWeight,
          x: 190,
          y: 58.5,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 1',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 0 }),
          x: 75,
          y: 64.5,
          width: 22,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 2',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 1 }),
          x: 75,
          y: 69.6,
          width: 22,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 3',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 2 }),
          x: 75,
          y: 74.7,
          width: 22,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 4',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 3 }),
          x: 75,
          y: 79.8,
          width: 22,
        },
        {
          name: 'Prescriber Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 115,
          y: 67.6,
          width: 86,
        },
        {
          name: 'Prescriber Email',
          type: 'text',
          getValue: getPrescriberFullAddress,
          x: 115,
          y: 71,
          width: 86,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Prescriber Phone 1',
          type: 'text',
          getValue: getPrescriberPhone1,
          x: 118.5,
          y: 80.5,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 2',
          type: 'text',
          getValue: getPrescriberPhone2,
          x: 130,
          y: 80.5,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 3',
          type: 'text',
          getValue: getPrescriberPhone3,
          x: 143,
          y: 80.5,
          width: 14,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber NSC or NPI',
          type: 'text',
          getValue: getPrescriberNPI,
          x: 176,
          y: 80.5,
          width: 25,
        },
        {
          name: 'EST LENGTH OF NEED',
          type: 'text',
          x: 67,
          y: 93,
          width: 9,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'DIAGNOSIS CODES',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 135,
          y: 93,
          width: 65,
        },
        {
          name: 'Does the patient have chronic, intractable pain?',
          type: 'radio',
          options: [
            {
              x: 21.5,
              y: 109.5,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 30,
              y: 109.5,
              width: 2,
              height: 2,
              value: 'N',
            },
          ],
        },
        {
          name: 'How long has the patient had intractable pain? (Enter number of months, 1–99)',
          type: 'text',
          x: 16.5,
          y: 114,
          width: 12,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Is the TENS unit being prescribed for any of the following conditions? (Check appropriate number) 1 - Headache 2 - Visceral abdominal pain 3 - Pelvic pain 4 - Temporomandibular joint (TMJ) pain 5 - None of the above',
          type: 'radio',
          options: [
            {
              x: 19.5,
              y: 124.5,
              width: 2,
              height: 2,
              value: '1',
            },
            {
              x: 26,
              y: 124.5,
              width: 2,
              height: 2,
              value: '2',
            },
            {
              x: 32,
              y: 124.5,
              width: 2,
              height: 2,
              value: '3',
            },
            {
              x: 23,
              y: 128.5,
              width: 2,
              height: 2,
              value: '4',
            },
            {
              x: 29,
              y: 128.5,
              width: 2,
              height: 2,
              value: '5',
            },
          ],
        },
        {
          name: 'Is there documentation in the medical record of multiple medications and/or other therapies that have been tried and failed?',
          type: 'radio',
          options: [
            {
              x: 21.5,
              y: 138.5,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 30,
              y: 138.5,
              width: 2,
              height: 2,
              value: 'N',
            },
          ],
        },
        {
          name: 'Has the patient received a TENS trial of at least 30 days?',
          type: 'radio',
          options: [
            {
              x: 21.5,
              y: 146.5,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 30,
              y: 146.5,
              width: 2,
              height: 2,
              value: 'N',
            },
          ],
        },
        {
          name: 'What is the date that you reevaluated the patient at the end of the trial period? 1',
          type: 'text',
          x: 17,
          y: 152,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'What is the date that you reevaluated the patient at the end of the trial period? 2',
          type: 'text',
          x: 25.5,
          y: 152,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'What is the date that you reevaluated the patient at the end of the trial period? 3',
          type: 'text',
          x: 33,
          y: 152,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'NAME OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 24,
          y: 162,
          width: 62,
        },
        {
          name: 'TITLE OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 97,
          y: 162,
          width: 40,
        },
        {
          name: 'EMPLOYER OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 154,
          y: 162,
          width: 47,
        },
        {
          name: '(1) Narrative description of all items, accessories and options ordered; (2) Supplier’s charge; and (3) Medicare Fee Schedule Allowance for each item, accessory, and option',
          type: 'text',
          getValue: getOrderLineNarrativeDescriptionAndCost,
          x: 15,
          y: 182,
          width: 186,
          height: 45,
          multiline: true,
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 48,
          y: 250,
          width: 90,
          height: 10,
        },
        {
          name: 'Date 1',
          type: 'text',
          x: 159,
          y: 256,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 2',
          type: 'text',
          x: 167,
          y: 256,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 3',
          type: 'text',
          x: 175,
          y: 256,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
      ],
    },
  ],
};

export default CMS848;



// WEBPACK FOOTER //
// ./src/config/documents/CMS-848.js